import React, { useRef, useEffect } from 'react';
import { ReactComponent as SearchIcon } from '../../../../../assets/icon/search.svg';
import { useTranslation } from 'react-i18next';
import SearchResult from '../Search/SearchResult';
import { SearchResultType } from '../../../../../interfaces/types';

interface SearchBarProps {
  input: string;
  isInputFocused: boolean;
  searchResult: SearchResultType | undefined;
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  onBlur?: () => void;
  onFoodClick?: (food: any, categoryId: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({
  input,
  isInputFocused,
  searchResult,
  onSearch,
  onFocus,
  onBlur,
  onFoodClick,
}) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (inputRef.current && !inputRef.current.contains(event.target as Node)) {
        onBlur?.();
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [onBlur]);

  const isInputEmpty = input.trim() === '';

  return (
    <div className="sticky top-0 z-10 flex items-center justify-center p-[15px]" style={{ background: 'var(--Primary-500, #3D9F4A)' }}>
      <div className="relative w-full">
        <SearchIcon className="absolute left-2 top-1/2 -translate-y-1/2 text-green-600" />
        <input
          ref={inputRef}
          type="search"
          className="w-full py-3 pl-8 pr-2 text-sm text-gray-700 border border-gray-300 rounded-lg bg-white focus:ring-green-600 focus:border-green-600 outline-none"
          placeholder={t('HOME_SEARCH_PLACEHOLDER')}
          onChange={onSearch}
          onFocus={onFocus}
        />

        {!isInputEmpty && isInputFocused && onFoodClick && (
          <SearchResult
            searchResult={searchResult}
            inputValue={input}
            onFoodClick={onFoodClick}
          />
        )}
      </div>
    </div>
  );
};

export default SearchBar;
